export const SET_DATA_OPTOUT = 'SET_DATA_OPTOUT';
export const SET_DATA_OPTOUT_DONE = 'SET_DATA_OPTOUT_DONE';
export const SET_DATA_OPTOUT_ERR = 'SET_DATA_OPTOUT_ERR';
export const SET_DATA_OPTOUT_RESET = 'SET_DATA_OPTOUT_RESET';
//# sourceMappingURL=actionTypes.js.map